const messages = {
  addDate: 'Select a date range',
  addDateFilter: 'Add Date as Filter',
  toasterSuccess: 'Filters Applied',
  filterBy: 'Filter By',
  errorText: 'Remove selection(s) and Re-apply filters',
  actionText: 'Apply Filters',
}

export default messages
